import { EntityModel } from '@/interfaces'
import {
  ALL_RATIO_CATALOG_BUNDLES_QUERY,
  CREATE_RATIO_CATALOG_BUNDLE_MUTATION,
  DELETE_RATIO_CATALOG_BUNDLE_MUTATION,
  FORCE_DELETE_RATIO_CATALOG_BUNDLE_MUTATION,
  SINGLE_RATIO_CATALOG_BUNDLE_QUERY,
  UPDATE_RATIO_CATALOG_BUNDLE_MUTATION,
} from './graphql'

const ratioCatalogBundleModel: EntityModel = {
  name: 'ratioCatalogBundle',
  namePlural: 'ratioCatalogBundles',
  uniqueName: 'ratioCatalogBundle',
  uniqueNamePlural: 'ratioCatalogBundles',
  path: 'travel/pricing/adaptors/ratio/ratio_catalog_bundle',
  baseUrl: '/travel/pricing/adaptors/ratio/ratio_catalog_bundles',
  translationPrefix: 'entities:ratioCatalogBundle.',
  getDisplayName: (values: any) => {
    return 'Ratio Catalog Bundle'
  },
  gql: {
    getAll: ALL_RATIO_CATALOG_BUNDLES_QUERY,
    getSingle: SINGLE_RATIO_CATALOG_BUNDLE_QUERY,
    create: CREATE_RATIO_CATALOG_BUNDLE_MUTATION,
    update: UPDATE_RATIO_CATALOG_BUNDLE_MUTATION,
    delete: DELETE_RATIO_CATALOG_BUNDLE_MUTATION,
    forceDelete: FORCE_DELETE_RATIO_CATALOG_BUNDLE_MUTATION,
  },
  attributes: {
    catalogCode: {
      name: 'catalogCode',
      label: 'entities:ratioCatalogBundle.attributes.catalogCode.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    travelCode: {
      name: 'travelCode',
      label: 'entities:ratioCatalogBundle.attributes.travelCode.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    json: {
      name: 'json',
      label: 'entities:ratioCatalogBundle.attributes.json.label',
      type: 'value',
      dataType: '{ [x: string]: any }',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioCatalogBundleModel
